import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { login } from "./Redux/slices/auth";
import { useAppDispatch, useAppSelector } from "./Redux/store";
import { useWhoAmI } from "./apis/auth/who-am-i";
import { useGetNotifications } from "./apis/notifications/get-notification";
import DashboardLayout from "./components/DashboardLayout";
import PrivateRoute from "./components/PrivateRoute";
import ServiceDetails from "./pages/ServiceDetails";
import Withdrawl from "./components/Withdraw";
import firebase from "./firebase";
import socket from "./lib/socket-io";
import Admins from "./pages/Admins";
import Analytics from "./pages/Analytics";
import Announcements from "./pages/Announcements";
import BusinessAccountDetail from "./pages/BusinessAccountDetail";
import Dashboard from './pages/Dashboard';
import DashboardDrivers from "./pages/DashboardDrivers";
import DashboardUsers from "./pages/DashboardUsers";
import DriverDetails from "./pages/DriverDetails";
import Feedback from "./pages/Feedback";
import HelpDesk from "./pages/HelpDesk";
import Offers from "./pages/Offers";
import PromoCodes from "./pages/PromoCodes";
import ServicesDashboard from "./pages/ServicesDashboard";
import AccountSettings from "./pages/Settings";
import States from "./pages/States";
import SubmissionRequests from "./pages/SubmissionRequests";
import SubsriptionPlanScreen from "./pages/SubscriptionPlanScreen";
import UserDetails from "./pages/UserDetails";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from './pages/auth/Login';
import { getSessionCookie } from './utils/cookies';
import BusinessAccounts from "./pages/BusinessAccounts";
import InDevelopment from "./components/InDevelopment";
import Error from "./components/Error";
import Batches from "./pages/Batches";
import BatchDetails from "./pages/BatchDetails";
import BatchConfig from "./pages/BatchConfig";
function App() {
  const dispatch = useAppDispatch();
  const accessToken = getSessionCookie("accessToken");
  const userId = useAppSelector((state) => state?.auth.user?._id);

  const messaging = firebase.messaging.isSupported()
    ? firebase.messaging()
    : null;

  const { data: whoAmIData } = useWhoAmI();
  const { mutate: registerFcmToken } = useGetNotifications();

  useEffect(() => {
    if (whoAmIData) {
      dispatch(login(whoAmIData));
    }
  }, [whoAmIData]);

  useEffect(() => {
    if (!accessToken) return;
    messaging
      ?.getToken({
        vapidKey: "BLwe3ejWxaUV3oN63ING_wjzYkfnWBZjJ4_mUK206S4JucYf42C_Eun9ic2p3PuiZeE0X0nC4qSftRo2QcHRPvo",
      })
      .then((currentToken: any) => {
        if (currentToken) {
          registerFcmToken(currentToken);
        } else {
          console.log("No registration token available. Request permission to generate one.");
        }
      })
      .catch((err: any) => {
        console.log("An error occurred while retrieving token.", err);
      });
  }, [accessToken]);

  useEffect(() => {
    socket.on("connect", () => console.log("socket connected"));
    socket.on("on_join", (data) => console.log("Socket: On Join", data));
    socket.on("exit", (data) => console.log("Socket: On Exit", data));
    socket.on("disconnect", (data) => console.log("Socket: On Disconnect", data));
  }, []);

  useEffect(() => {
    if (socket.connected && userId) {
      socket.emit("join", userId);
    }
  }, [userId]);

  return (
    <ErrorBoundary FallbackComponent={Error}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="business" element={<BusinessAccounts />} />
            <Route path="business/:id" element={<BusinessAccountDetail />} />
            <Route path="users" element={<DashboardUsers />} />
            <Route path="drivers" element={<DashboardDrivers />} />
            <Route path="accountSettings" element={<AccountSettings />} />
            <Route path="users/:id" element={<UserDetails />} />
            <Route path="drivers/:id" element={<DriverDetails />} />
            <Route path="orders" element={<ServicesDashboard />} />
            <Route path="withdraw" element={<Withdrawl />} />
            <Route path="orders/:id" element={<ServiceDetails />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="help-desk" element={<HelpDesk />} />
            <Route path="driver-documentation-update-requests" element={<SubmissionRequests />} />
            <Route path="admins" element={<Admins />} />
            <Route path="states" element={<States />} />
            <Route path="promo-codes" element={<PromoCodes />} />
            <Route path="subscription-plans" element={<SubsriptionPlanScreen />} />
            <Route path="offers" element={<Offers />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="*" element={<InDevelopment />} />
            <Route path="batches" element={<Batches />} />
            <Route path="batches/:id" element={<BatchDetails />} />
            <Route path="batch-configs" element={<BatchConfig />} />

          </Route>
        </Route>
        <Route path="/*" element={<Navigate to="/login" />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;